import {ABACPolicyEntity} from "@ots-frontend/ots-data";
import {Card, Divider, Grid, Group, Text, Title} from "@mantine/core";
import {useTranslation} from "react-i18next";

export type ABACPolicyDetailsProps = {
  abacPolicy: ABACPolicyEntity
}

export const ABACPolicyDetails = (props: ABACPolicyDetailsProps) => {
  const {abacPolicy} = props;

  const {t} = useTranslation(["common"]);

  return (
    <Grid>
      <Grid.Col span={12}>
        <Card shadow="sm" padding="lg" radius="md" withBorder>

          <Group position="apart" pb="sm">
            <Title order={4}>{
              t("common.entity.abacpolicy.profile.info.section.details.label", "Details")}
            </Title>
          </Group>

          <Divider/>

          <Grid>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.abacpolicy.profile.info.field.name.label", "Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {abacPolicy.name}
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.abacpolicy.profile.info.field.description.label", "Description")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {abacPolicy.description}
              </Text>
            </Grid.Col>
          </Grid>
        </Card>
      </Grid.Col>
    </Grid>
  );
};
